module.exports = __webpack_public_path__ + "static/media/percent.17e7720c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/percent.svg
// module id = 214
// module chunks = 8